(() => {
  'use strict';
  const script = document.currentScript;
  const template = document.getElementById('pe-scratch-template');
  if (!template || !script) return;
  const initialized = new WeakSet();
  const peeker = document.querySelector('[data-offer-peeker]');
  const storageKey = 'pe-scratch-session-v1';
  let saved = {};
  try { saved = JSON.parse(sessionStorage.getItem(storageKey)) || {}; } catch (_) {}
  if (!saved || typeof saved !== 'object' || Array.isArray(saved)) saved = {};
  const persist = () => { try { sessionStorage.setItem(storageKey, JSON.stringify(saved)); } catch (_) {} };
  let opening = false, openingTimer, updateQueued = false;
  const visible = el => !!el && el.getBoundingClientRect().height > 0 && getComputedStyle(el).visibility !== 'hidden';
  function updatePeeker() {
    if (!peeker || updateQueued) return;
    updateQueued = true;
    requestAnimationFrame(() => {
      updateQueued = false;
      const blocked = [...document.querySelectorAll('dialog[open],[role="dialog"],.pe-mobile-menu[open]')].some(visible);
      const hide = !saved.closed || saved.dismissed || saved.submitted || opening || blocked || /\/cart(?:\/|$)/.test(location.pathname);
      if (peeker.hidden !== !!hide) peeker.hidden = !!hide;
      const sticky = document.querySelector('.pe-sticky-purchase');
      const rect = sticky?.getBoundingClientRect();
      let bottom = visible(sticky) && rect.top < innerHeight && rect.bottom > 0 ? Math.ceil(innerHeight - rect.top + 12) : 16;
      const previewBar = document.getElementById('PBarNextFrameWrapper');
      const previewRect = previewBar?.getBoundingClientRect();
      if (visible(previewBar) && previewRect.top > innerHeight / 2 && previewRect.top < innerHeight) bottom = Math.max(bottom, Math.ceil(innerHeight - previewRect.top + 12));
      const value = bottom + 'px';
      if (peeker.style.getPropertyValue('--pe-offer-bottom') !== value) peeker.style.setProperty('--pe-offer-bottom', value);
    });
  }
  peeker?.querySelector('[data-offer-open]').addEventListener('click', () => {
    if (opening || saved.submitted) return;
    opening = true; updatePeeker();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'TXSmD3']);
    clearTimeout(openingTimer);
    openingTimer = setTimeout(() => { opening = false; updatePeeker(); }, 6000);
  });
  peeker?.querySelector('[data-offer-hide]').addEventListener('click', () => {
    saved.dismissed = true; persist(); updatePeeker();
  });
  window.addEventListener('klaviyoForms', event => {
    if (event.detail?.formId !== 'TXSmD3') return;
    if (event.detail.type === 'submit') { saved.submitted = true; saved.closed = false; persist(); }
    if (event.detail.type === 'close' && saved.seen) { saved.closed = true; persist(); }
    if (event.detail.type === 'open') { opening = false; clearTimeout(openingTimer); }
    updatePeeker();
  });
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.target.matches('dialog,[role="dialog"],.pe-mobile-menu,.pe-sticky-purchase,#PBarNextFrame,#PBarNextFrameWrapper') || record.target.closest('[role="dialog"]'))) updatePeeker();
  }).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['open','hidden','class','style']});
  window.addEventListener('scroll', updatePeeker, {passive:true});
  window.addEventListener('resize', updatePeeker);
  updatePeeker();
  function enhance(form) {
    if (initialized.has(form) || !form.querySelector('input[type="email"]')) return;
    const headline = form.querySelector('.polieco-offer-copy p')?.textContent || '';
    const offer = headline.includes('$15') ? '$15 off' : headline.includes('15%') ? '15% off' : null;
    const host = form.closest('[data-testid="modal-form-container"]');
    const dialog = form.closest('[role="dialog"]');
    const close = host?.querySelector('.klaviyo-close-form');
    if (!offer || !host || !dialog || !close) return;
    const panel = template.content.firstElementChild.cloneNode(true);
    const canvas = panel.querySelector('canvas');
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return;
    initialized.add(form);
    saved.seen = true; opening = false; clearTimeout(openingTimer);
    // State belongs to the native assigned offer; never rewrite Klaviyo's experiment or hidden fields.
    saved.offers = saved.offers || {};
    const progress = saved.offers[offer] || {strokes:[],revealed:false,claimed:false};
    saved.offers[offer] = progress; persist(); updatePeeker();
    close.addEventListener('click', () => { saved.closed = true; persist(); updatePeeker(); });
    dialog.classList.add('pe-scratch-dialog');
    const originalLabel = dialog.getAttribute('aria-label');
    panel.querySelector('[data-scratch-reward]').textContent = offer;
    host.insertBefore(panel, form);
    host.classList.add('pe-scratch-host', 'pe-scratch-covered');
    dialog.setAttribute('aria-label', panel.getAttribute('aria-label'));
    for (const column of form.children) {
      if (column.tagName === 'DIV') column.classList.add(column.querySelector('input[type="email"]') ? 'pe-scratch-fields' : 'pe-scratch-photo');
    }
    const revealButton = panel.querySelector('[data-scratch-reveal]');
    const continueButton = panel.querySelector('[data-scratch-continue]');
    let revealed = false, activePointer = null, last = null;
    function reveal() {
      if (revealed) return;
      revealed = true; progress.revealed = true; persist(); canvas.hidden = true;
      panel.querySelector('[data-scratch-status]').textContent = offer;
      revealButton.hidden = true; continueButton.hidden = false;
      continueButton.focus({ preventScroll: true });
    }
    revealButton.addEventListener('click', reveal);
    function claim() {
      progress.claimed = true; persist();
      host.classList.remove('pe-scratch-covered'); panel.remove();
      document.removeEventListener('keydown', keyboard, true);
      if (originalLabel) dialog.setAttribute('aria-label', originalLabel);
      form.querySelector('input[type="email"]')?.focus({ preventScroll: true });
    }
    continueButton.addEventListener('click', claim);
    panel.querySelector('[data-scratch-dismiss]').addEventListener('click', () => close.click());
    function keyboard(event) {
      if (!panel.isConnected) { document.removeEventListener('keydown', keyboard, true); return; }
      if (event.key === 'Escape') { event.preventDefault(); event.stopImmediatePropagation(); close.click(); }
      if (event.key !== 'Tab') return;
      const controls = [close, revealed ? continueButton : revealButton, panel.querySelector('[data-scratch-dismiss]')];
      const index = controls.indexOf(document.activeElement);
      event.preventDefault(); event.stopImmediatePropagation();
      controls[(index + (event.shiftKey ? controls.length - 1 : 1)) % controls.length].focus();
    }
    document.addEventListener('keydown', keyboard, true);
    const removal = new MutationObserver(() => {
      if (host.isConnected) return;
      removal.disconnect(); document.removeEventListener('keydown', keyboard, true);
      updatePeeker();
      requestAnimationFrame(() => { if (peeker && !peeker.hidden) peeker.querySelector('[data-offer-open]').focus({preventScroll:true}); });
    });
    removal.observe(document.body, { childList: true, subtree: true });
    requestAnimationFrame(() => {
      if (!panel.isConnected) return;
      const rect = canvas.getBoundingClientRect();
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round((rect.width || 310) * ratio); canvas.height = Math.round((rect.height || 124) * ratio);
      const w = canvas.width, h = canvas.height;
      const foil = ctx.createLinearGradient(0, h, w, 0);
      [[0,'#AA803D'],[0.22,'#D5B36A'],[0.43,'#F0DEA6'],[0.57,'#D6B56E'],[0.8,'#BE9650'],[1,'#E8D293']].forEach(([stop,color]) => foil.addColorStop(stop,color));
      ctx.fillStyle = foil; ctx.fillRect(0, 0, w, h);
      let seed = 2947;
      const random = () => { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; };
      for (let i = 0; i < w * h / 12; i++) {
        ctx.fillStyle = random() > 0.5 ? 'rgba(255,248,218,0.14)' : 'rgba(105,73,30,0.1)';
        ctx.fillRect(random() * w, random() * h, (0.5 + random() * 2) * ratio, 0.5 * ratio);
      }
      ctx.strokeStyle = 'rgba(80,57,47,0.28)'; ctx.lineWidth = ratio;
      ctx.strokeRect(7 * ratio, 7 * ratio, w - 14 * ratio, h - 14 * ratio);
      ctx.fillStyle = '#50392F'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = `${16 * ratio}px Arial`;
      ctx.fillText(script.dataset.scratchLabel, canvas.width / 2, canvas.height / 2);
      for (const stroke of progress.strokes) {
        last = null;
        for (const point of stroke) paint({x:point.x * canvas.width,y:point.y * canvas.height});
      }
      last = null;
      if (progress.claimed) claim();
      else if (progress.revealed) reveal();
      else revealButton.focus({ preventScroll: true });
    });
    let stroke = null;
    function paint(next) {
      ctx.globalCompositeOperation = 'destination-out'; ctx.lineWidth = canvas.width * 0.14; ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo((last || next).x, (last || next).y); ctx.lineTo(next.x + 0.01, next.y); ctx.stroke(); last = next;
    }
    function erase(event) {
      const rect = canvas.getBoundingClientRect();
      const next = {x:(event.clientX-rect.left)*canvas.width/rect.width,y:(event.clientY-rect.top)*canvas.height/rect.height};
      paint(next);
      if (stroke && stroke.length < 2000) stroke.push({x:next.x/canvas.width,y:next.y/canvas.height});
    }
    canvas.addEventListener('pointerdown', event => {
      if (revealed || activePointer !== null) return;
      stroke = []; progress.strokes.push(stroke);
      activePointer = event.pointerId; last = null; canvas.setPointerCapture(event.pointerId); erase(event);
    });
    canvas.addEventListener('pointermove', event => { if (event.pointerId === activePointer) erase(event); });
    function end(event) {
      if (event.pointerId !== activePointer) return;
      activePointer = null; last = null;
      const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
      let cleared = 0, sampled = 0;
      for (let i = 3; i < pixels.length; i += 64) { sampled++; if (pixels[i] < 128) cleared++; }
      if (cleared / sampled >= 0.35) reveal();
      persist();
    }
    canvas.addEventListener('pointerup', end); canvas.addEventListener('pointercancel', end);
  }
  let queued = false;
  function scan() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; document.querySelectorAll('[data-testid="klaviyo-form-TXSmD3"]').forEach(enhance); });
  }
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true }); scan();
  if (script.dataset.scratchPreview === 'true' && new URLSearchParams(location.search).get('pe_scratch_preview') === '1') {
    window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', 'TXSmD3']);
  }
})();
